import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from '@app/services/common.service';
import { c_components } from 'src/3ui/2components';
import { Helper } from '../../../../../4services/2helper'
import ims from '../../imports'
import { BaseComponent } from '@app/directives/base-component'

@Component({
    selector: 'c_dtable_site_default_settings_for_new_site',
    templateUrl: './c_dtable_site_default_settings_for_new_site.component.html',
    styleUrls: ['../../common.scss', '../site_default_settings.scss'],
    standalone: false
})
export class c_dtable_site_default_settings_for_new_site_component extends BaseComponent {
  isLoading = false;

  tableHeader = [
    { name: 'SETTINGS', value: 'site_name', width: "20%", isCheckbox: false },
    { name: 'CHEKT DEFAULT VALUES', value: 'dealer_name', width: "15%", isCheckbox: false },
    { name: 'DEALER DEFAULT VALUES', value: 'video_events', width: "50%", isCheckbox: false },
  ]
  isEditMode = false;

  // selected settings
  isAllSelected = false;
  filteredSiteList = [];

  // validate
  isHasError = {
    zoneNumberRange: false,
    alarmInterval: false,
    swingerBypass: false,
    mp4VideoSettingsPre: false,
    mp4VideoSettingsPost: false,
    over20: false,
    idleThreshold: false,
    dormantThreshold: false,
  };

  // for new sites
  originSiteSettings = {
    zoneNumberRange: 101,
    alarmInterval: 20,
    swingerBypass: 0,
    swingerBypassResetTimer: 0,
    mp4VideoSettings: { pre: 7, post: 25 },
    timeSync: true,
    autoSetStream: true,
    autoSetStreamSpec: '720p@8fps@16GoP@1500vbr@h264',
    isAudioEnabled: false,
    isIdleDormantEnabled: true,
    idleThreshold: 1,
    dormantThreshold: 7,
  }
  newSiteSettings = {
    zoneNumberRange: 101,
    alarmInterval: 20,
    swingerBypass: 0,
    swingerBypassResetTimer: 0,
    mp4VideoSettings: { pre: 7, post: 25 },
    timeSync: true,
    autoSetStream: true,
    autoSetStreamSpec: '720p@8fps@16GoP@1500vbr@h264',
    isAudioEnabled: false,
    isIdleDormantEnabled: true,
    idleThreshold: 1,
    dormantThreshold: 7,
  }

  // full site_default_setting from the server (all required fields), kept to merge on save
  private rawSiteDefaultSetting: any = null;

  constructor(
    public commonService: CommonService,
    private helper: Helper,
    private c_components: c_components
  ) { super(); }

  private dealerDefaultMpSettings$w: Subscription;
  watch() {
    this.dealerDefaultMpSettings$w = this.helper.mp_settings.dealerDefaultMpSettings$w().subscribe((v) => this.onChangeSiteDefaultSettings(v));
  }
  unwatch() {
    this.dealerDefaultMpSettings$w?.unsubscribe();
  }

  async ngOnInit() {
    this.isLoading = true;
    
    this.initData()
    this.watch();
    await this.loadData();
    this.isLoading = false;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.unwatch();
  }

  initData(){
    this.newSiteSettings = {
      zoneNumberRange: 101,
      alarmInterval: 20,
      swingerBypass: 0,
      swingerBypassResetTimer: 0,
      mp4VideoSettings: { pre: 7, post: 25 },
      timeSync: true,
      autoSetStream: true,
      autoSetStreamSpec: '720p@8fps@16GoP@1500vbr@h264',
      isAudioEnabled: false,
      isIdleDormantEnabled: true,
      idleThreshold: 86400,
      dormantThreshold: 604800,
    }
    this.originSiteSettings = ims._.cloneDeep(this.newSiteSettings)
    this.isHasError = {
      zoneNumberRange: false,
      alarmInterval: false,
      swingerBypass: false,
      mp4VideoSettingsPre: false,
      mp4VideoSettingsPost: false,
      over20: false,
      idleThreshold: false,
      dormantThreshold: false,
    };
  }

  async loadData() {
    await this.helper.mp_settings.load_dealer_default_mp_settings();
  }
  onChangeSiteDefaultSettings(value) {
    if(!value) return;
    const data = value
    const { site_default_setting, auto_set_stream_spec } = data
    const settingsData = JSON.parse(site_default_setting)
    this.rawSiteDefaultSetting = settingsData;
    const {
      init_zone_number,
      is_time_sync_enabled,
      auto_resolution_enabled,
      recording_interval_seconds,
      pre_event_mp4_second,
      post_event_mp4_second,
      swinger_bypass_threshold,
      swinger_bypass_reset_after,
      is_audio_enabled,
      idle_threshold_seconds,
      dormant_threshold_seconds,
      is_activity_monitoring_enabled,
    } = settingsData

    this.originSiteSettings = {
      zoneNumberRange: init_zone_number,
      alarmInterval: recording_interval_seconds,
      swingerBypass: swinger_bypass_threshold,
      swingerBypassResetTimer: Math.round((swinger_bypass_reset_after ?? 0) / 60),
      mp4VideoSettings: { pre: pre_event_mp4_second, post: post_event_mp4_second },
      timeSync: is_time_sync_enabled ? true : false,
      autoSetStream: auto_resolution_enabled ? true : false,
      autoSetStreamSpec: auto_set_stream_spec,
      isAudioEnabled: is_audio_enabled ? true : false,
      isIdleDormantEnabled: is_activity_monitoring_enabled ? true : false,
      idleThreshold: idle_threshold_seconds / 86400,
      dormantThreshold: dormant_threshold_seconds / 86400,
    }
    this.newSiteSettings = {
      zoneNumberRange: init_zone_number,
      alarmInterval: recording_interval_seconds,
      swingerBypass: swinger_bypass_threshold,
      swingerBypassResetTimer: Math.round((swinger_bypass_reset_after ?? 0) / 60),
      mp4VideoSettings: { pre: pre_event_mp4_second, post: post_event_mp4_second },
      timeSync: is_time_sync_enabled ? true : false,
      autoSetStream: auto_resolution_enabled ? true : false,
      autoSetStreamSpec: auto_set_stream_spec,
      isAudioEnabled: is_audio_enabled ? true : false,
      isIdleDormantEnabled: is_activity_monitoring_enabled ? true : false,
      idleThreshold: idle_threshold_seconds / 86400,
      dormantThreshold: dormant_threshold_seconds / 86400,
    }

    const pre = pre_event_mp4_second
    const post = post_event_mp4_second
    const holdTime = recording_interval_seconds
    if(pre + post > 20 && post > holdTime ){
      this.isHasError.over20 = true;
    }
  }

  // -----------------------------------------
  // TOOLS
  toggleAllCheckbox() {
    this.isAllSelected = !this.isAllSelected
  }

  // -----------------------------------------
  // VALIDATE
  validateZoneNumberRange(){
    this.isHasError.zoneNumberRange = false;
    if(this.newSiteSettings.zoneNumberRange < 1 || this.newSiteSettings.zoneNumberRange > 600) {
      this.isHasError.zoneNumberRange = true;
    }
  }
  validateAlarmInterval(){
    this.isHasError.alarmInterval = false;
    if(this.newSiteSettings.alarmInterval < 10 || this.newSiteSettings.alarmInterval > 3600) {
      this.isHasError.alarmInterval = true;
    }
    this.validateMp4VideoLengthOver20()
  }
  validateMp4VideoSettingsPre(){
    this.isHasError.mp4VideoSettingsPre = false;
    if(this.newSiteSettings.mp4VideoSettings.pre < 5 || this.newSiteSettings.mp4VideoSettings.pre > 10) {
      this.isHasError.mp4VideoSettingsPre = true;
    }
    this.validateMp4VideoLengthOver20()
  }
  validateMp4VideoSettingsPost(){
    this.isHasError.mp4VideoSettingsPost = false;
    if(this.newSiteSettings.mp4VideoSettings.post < 10 || this.newSiteSettings.mp4VideoSettings.post > 60) {
      this.isHasError.mp4VideoSettingsPost = true;
    }
    this.validateMp4VideoLengthOver20()
  }
  validateIdleThreshold(){
    if(this.newSiteSettings.idleThreshold < 1) {
      this.newSiteSettings.idleThreshold = 1;
    }
    if(this.newSiteSettings.idleThreshold > 30) {
      this.newSiteSettings.idleThreshold = 30;
    }
    this.isHasError.idleThreshold = false;
    this.isHasError.dormantThreshold = this.newSiteSettings.dormantThreshold <= this.newSiteSettings.idleThreshold;
  }
  validateDormantThreshold(){
    if(this.newSiteSettings.dormantThreshold < 3) {
      this.newSiteSettings.dormantThreshold = 3;
    }
    if(this.newSiteSettings.dormantThreshold > 90) {
      this.newSiteSettings.dormantThreshold = 90;
    }
    this.isHasError.dormantThreshold = this.newSiteSettings.dormantThreshold <= this.newSiteSettings.idleThreshold;
  }
  validateMp4VideoLengthOver20(){
    this.isHasError.over20 = false;
    const pre = this.newSiteSettings.mp4VideoSettings.pre
    const post = this.newSiteSettings.mp4VideoSettings.post
    const holdTime = this.newSiteSettings.alarmInterval

    if(pre + post > 20 && post > holdTime ){
      this.isHasError.over20 = true;
    }
  }
  isDisabledSave(){
    const value = Object.values(this.isHasError)
    return value.some(v => v === true)
  }

  // -----------------------------------------
  // STYLES
  setTooltipPosition(target) {
    let tooltipBox = document.querySelector('#'+target +'-box');
    let tooltip = document.getElementById(target);
    let rect = tooltipBox.getBoundingClientRect();
    let tooltipRect = tooltip.getBoundingClientRect();
    let posX = rect.left + (rect.right - rect.left) - tooltipRect.width/2;
    const posY = rect.top - tooltipRect.height - 55;
    if(!this.commonService.isHide) posX = posX - 200;
    tooltip.style.left = posX + 'px';
    tooltip.style.top = posY + 'px';
  }

  computedStreamSpec(){
    const spec = this.originSiteSettings.autoSetStreamSpec ?? '';
    const resolutionLabel = spec.includes('720p') ? 'HD (720p, 8fps' : 'SD (360p, 6fps';
    const rateControlLabel = spec.includes('cbr') ? ', CBR)' : ', VBR)';
    return resolutionLabel + rateControlLabel;
  }
  computedTagStyleClass(value){
    return value ? 'enabled' : 'disabled'
  }

  // ------------------------------------------------------------------------
  // ACTION 
  onClickCancel(){
    this.newSiteSettings = ims._.cloneDeep(this.originSiteSettings)
    this.isEditMode = false;
  }

  onClickSave(){
    if(this.isDisabledSave()) return;
    this.c_components.dialog.open("warning", {
      header: `Update the settings for the new site`,
      contents: `The changes will be applied starting from newly created sites.`,
      submit_btn: "Update",
      submit_class: ["button-primary"],
      icon: 'warning',
      isConfirm: false,
      color: 'orange',
      submit_func: () => {
        this.saveSettings()
      },
      cancel_func: () => this.onClickCancel(),
    });
  }
  
  async saveSettings(){
    try {
      this.isLoading = true
      // api call
      // keep all existing (required) site_default_setting fields, override only what we edit.
      // entry_delay / exit_delay are owned by the Partition tab now, so they are left untouched
      // (preserved via ...base) and partition_default_settings are not wiped.
      const base = this.rawSiteDefaultSetting ? ims._.cloneDeep(this.rawSiteDefaultSetting) : {};
      const data = {
        site_default_setting: {
          ...base,
          init_zone_number: this.newSiteSettings.zoneNumberRange,
          recording_interval_seconds: this.newSiteSettings.alarmInterval,
          swinger_bypass_threshold: this.newSiteSettings.swingerBypass,
          swinger_bypass_reset_after: this.newSiteSettings.swingerBypassResetTimer * 60,
          pre_event_mp4_second: this.newSiteSettings.mp4VideoSettings.pre,
          post_event_mp4_second: this.newSiteSettings.mp4VideoSettings.post,
          is_time_sync_enabled: this.newSiteSettings.timeSync ? 1 : 0,
          auto_resolution_enabled: this.newSiteSettings.autoSetStream ? 1 : 0,
          is_audio_enabled: this.newSiteSettings.isAudioEnabled ? 1 : 0,
          is_activity_monitoring_enabled: this.newSiteSettings.isIdleDormantEnabled ? 1 : 0,
          idle_threshold_seconds: this.newSiteSettings.idleThreshold * 86400,
          dormant_threshold_seconds: this.newSiteSettings.dormantThreshold * 86400,
        },
        auto_set_stream_spec: this.newSiteSettings.autoSetStreamSpec
      }
      await this.helper.mp_settings.update_dealer_default_site_settings(data)
      this.openConfirmDialog('Success', `The settings have been successfully applied for New Sites`, 'done', 'green')
      this.initData()
      await this.loadData()
      this.isEditMode = false;
      this.isLoading = false;
    } catch(err) {
      console.debug(err)
      this.isLoading = false;
    }
  }

  // ------------------------------------------------------------------------
  openConfirmDialog(header = "", msg = "", icon = "done", color = "green") {
    this.c_components.dialog.open("warning", {
      header: header,
      contents: `
        <p>${msg}</b></p>
      `,
      submit_btn: "OK",
      submit_class: ["button-primary"],
      icon: icon,
      isConfirm: true,
      color: color,
      submit_func: () => {},
    });
  }
}